import { PartnersData, PartnerViewModel } from "./PartnersModel";

export type PartnerSortOrder = "asc" | "desc";
const normalize = (text: string) =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const mapPartner = (
  partner: PartnersData,
  mediaBaseUrl: string,
  placeholder: string
): PartnerViewModel => {
  const logo = partner.attributes.logo?.data?.attributes?.url?.trim();
  return {
    id: partner.id,
    title: partner.attributes.title.trim(),
    logoUrl: logo ? `${mediaBaseUrl}${logo}` : placeholder,
    details: partner,
  };
};

export const filterAndSortPartners = (
  partners: PartnerViewModel[],
  query: string,
  order: PartnerSortOrder,
  locale: string
): PartnerViewModel[] => {
  const search = normalize(query);
  const collator = new Intl.Collator(locale, { sensitivity: "base", numeric: true, ignorePunctuation: true });
  return partners.filter((partner) => normalize(partner.title).includes(search))
    .sort((left, right) => {
      const compared = collator.compare(left.title, right.title);
      return (order === "asc" ? compared : -compared) || left.id - right.id;
    });
};
